(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("exceljs"));
	else if(typeof define === 'function' && define.amd)
		define(["exceljs"], factory);
	else if(typeof exports === 'object')
		exports["xlsxPreview"] = factory(require("exceljs"));
	else
		root["xlsxPreview"] = factory(root["exceljs"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__674__) {
return 